"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _preact = require("preact");

var _algoliaService = require("../../services/algoliaService");

var _algolia = require("@insided/shared/services/algolia");

var _utils = require("@insided/destination/modules/Search/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

/**
 * @deprecated This class violates React/Preact conventions and modern best practices:
 *
 * - **Composition over Inheritance**: React/Preact favors composition patterns (hooks, HOCs, render props)
 *   over class inheritance. Inheritance creates tight coupling and makes components harder to reuse.
 *
 * - **Component-Driven Development (CDD)**: CDD emphasizes building isolated, reusable components
 *   with clear boundaries. Inheritance breaks this isolation by creating implicit dependencies
 *   on parent class implementation details.
 *
 * - **React Team Recommendation**: The React team explicitly discourages using inheritance for
 *   component logic reuse. See: https://reactjs.org/docs/composition-vs-inheritance.html
 *
 * **Preferred alternatives:**
 * - Custom hooks (e.g., `useAlgoliaIndex()`)
 * - Higher-Order Components (HOCs)
 * - Render props pattern
 * - Component composition with props
 */
var _default = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(_default, _Component);

  var _super = _createSuper(_default);

  function _default(props) {
    var _this;

    (0, _classCallCheck2.default)(this, _default);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "algoliaIndex", void 0);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "initPromise", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "cb", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(data) {
        var client;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return (0, _algolia.createAlgoliaClient)(data.client_id, data.token);

              case 2:
                client = _context.sent;
                _this.algoliaIndex = client.initIndex((0, _utils.getCommunityId)());

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }());
    return _this;
  }

  (0, _createClass2.default)(_default, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
        var _this2 = this;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                // Create a promise that resolves when algoliaIndex is initialized
                this.initPromise = new Promise(function (resolve) {
                  var wrappedCallback = /*#__PURE__*/function () {
                    var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(data) {
                      return _regenerator.default.wrap(function _callee2$(_context2) {
                        while (1) {
                          switch (_context2.prev = _context2.next) {
                            case 0:
                              _context2.next = 2;
                              return _this2.cb(data);

                            case 2:
                              resolve();

                            case 3:
                            case "end":
                              return _context2.stop();
                          }
                        }
                      }, _callee2);
                    }));

                    return function wrappedCallback(_x2) {
                      return _ref2.apply(this, arguments);
                    };
                  }();

                  (0, _algoliaService.getSearchToken)(wrappedCallback);
                });
                _context3.next = 3;
                return this.initPromise;

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }]);
  return _default;
}(_preact.Component);

exports.default = _default;